<template>
  <section>
    <div class="container">
      <div v-show="nezet.tipus == 'urlap'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Rendkívüli szociális ösztöndíj
            </div>
          </div>

          <div class="col-xs-12">
            <div class="info-box warning">
              Amennyiben hibát talál <span class="highlight">személyes</span> vagy <span class="highlight">képzési adataiban</span>, kérjük lépjen kapcsolatba a tanulmányi ügyintézővel.
            </div>
          </div>

          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Személyes adatok
            </h5>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="nev" name="nev" disabled label="Név" v-model="form.values.nev"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="neptunkod" name="neptunkod" disabled label="Neptun azonosító" v-model="form.values.neptunkod"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="szuletesiHely" name="szuletesiHely" disabled label="Születési hely" v-model="form.values.szuletesiHely"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="szuletesiIdo" name="szuletesiIdo" disabled label="Születési idő" v-model="form.values.szuletesiIdo"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="anyjaNeve" name="anyjaNeve" disabled label="Anyja neve" v-model="form.values.anyjaNeve"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="telefonszam" name="telefonszam" disabled label="Telefonszám" v-model="form.values.telefonszam"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="emailCim" name="emailCim" disabled label="E-mail cím" v-model="form.values.emailCim"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Képzési adatok
            </h5>
          </div>
          <div class="col-xs-12">
            <comboboxV2 :errors="errors" @onChange="kepzesValt" label="Képzések" id="kepzesKodja" :options="kepzesek" v-model="form.values.kivalasztottKepzesKodja"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kar" name="kar" disabled label="Kar neve" v-model="form.values.kar"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="tagozat" name="tagozat" disabled label="Tagozat" v-model="form.values.tagozat"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesNeve" name="kepzesNeve" disabled label="Képzés" v-model="form.values.kepzesNeve"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesKodja" name="kepzesKodja" disabled label="Képzés kódja" v-model="form.values.kepzesKodja"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesSzintje" name="kepzesSzintje" disabled label="Képzés szintje" v-model="form.values.kepzesSzintje"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="hallgatoiStatusz" name="hallgatoiStatusz" disabled label="Hallgatói státusz" v-model="form.values.hallgatoiStatusz"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesHelye" name="kepzesHelye" disabled label="Képzés helye" v-model="form.values.kepzesHelye"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="penzugyiStatusz" name="penzugyiStatusz" disabled label="Pénzügyi státusz" v-model="form.values.penzugyiStatusz"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="osztondijindex" name="osztondijindex" disabled label="Ösztöndíjindex" v-model="form.values.osztondijindex"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Korábbi igénylés
            </h5>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input true-value="1" false-value="0" id="rendkivuliSzocialisTamogatasTanevben" type="checkbox" v-model="form.values.rendkivuliSzocialisTamogatasTanevben"/>
                <label for="rendkivuliSzocialisTamogatasTanevben">
                  <div class="icon"></div>
                  Igényelt már rendkívüli szociális támogatást ebben a tanévben?
                </label>
              </div>
              <div v-if="error.id == 'rendkivuliSzocialisTamogatasTanevben'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>
          <div class="col-xs-12" v-show="parseInt(form.values.rendkivuliSzocialisTamogatasTanevben) == 1 ? true : false">
            <inputbox :datepicker="true" :errors="errors" id="rendkivuliSzocialisTamogatasTanevbenIgenylesDatum" name="rendkivuliSzocialisTamogatasTanevbenIgenylesDatum" label="Igénylés dátuma" v-model="form.values.rendkivuliSzocialisTamogatasTanevbenIgenylesDatum"/>
          </div>
        </div>

        <div class="row" id="tamogatasok">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Támogatásra okot adó körülmények
            </h5>
          </div>
          <div class="col-xs-12" style="padding-bottom: 20px;" v-for="kategoria in kategoriak">
            <h6>
              {{  kategoria.megnevezes }}
            </h6>
            <div class="form-checkbox-wrapper" v-for="(tamogatas, i) in kategoria.tamogatasok">
              <input :value="tamogatas.id" multiple :id="'tamogatas_'+tamogatas.id" type="checkbox" v-model="form.values.tamogatasok"/>
              <label :for="'tamogatas_'+tamogatas.id">
                <div class="icon"></div>
                {{ tamogatas.megnevezes }}
              </label>
            </div>
          </div>
          <div class="col-xs-12 form-group">
            <div v-if="error.id == 'tamogatasok'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Feltöltendő dokumentumok
            </h5>
            <div class="info-box warning">
              Pályázathoz szükséges dokumentumokhoz az alábbi linken olvashatsz információkat:
              <a target="_blank" href="https://student.sze.hu/downloadmanager/download/nohtml/1/id/48621/m/16718">https://student.sze.hu/downloadmanager/download/nohtml/1/id/48621/m/16718</a>
            </div>
            <UploadHandler :max_uploaded_files="igazolasokMaxFeltolthetoFajl" @change="(value) => { form.values.igazolasok = value; }" msg="abc" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="igazolasok" label="A (támogatásra okot adó körülmény) igazolásához szükséges (fentebbi táblázat alapján)" name="igazolasok" :loaded_files="form.values.igazolasok"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Indoklás
            </h5>
            <textareabox :errors="errors" id="indoklas" :autogrow="true" label="Indoklás" name="indoklas" v-model="form.values.indoklas"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Igényelt összeg (HUF)
            </h5>
            <inputbox :errors="errors" regexp_filter="[0-9]+" id="igenyeltOsszeg" label="Igényelt összeg" name="igenyeltOsszeg" v-model="form.values.igenyeltOsszeg"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Hallgatói nyiltakozat
            </h5>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input true-value="1" false-value="0" id="nyilatkozatElfogadas" type="checkbox" v-model="form.values.nyilatkozatElfogadas"/>
                <label for="nyilatkozatElfogadas">
                  <div class="icon"></div>
                  A pályázat benyújtásával büntetőjogi felelősségem teljes tudatában kijelentem, hogy hamis adatok közlése esetén fegyelmi eljárás indulhat ellenem, mely a hallgatói jogviszony fegyelmi úton történő megszüntetését is eredményezheti. Továbbá hozzájárulok ahhoz, hogy adataimat a Széchenyi István Egyetem Hallgatói Önkormányzata nevében eljáró személyek a pályázat elbírálásával összefüggésben, a TJSZ-ben rögzített feltételeknek, illetve a személyi adatok védelméről és a közérdekű adatok nyilvánosságáról szóló 1992. évi LXIII. törvénynek megfelelően kezelje.
                </label>
              </div>
              <div v-if="error.id == 'nyilatkozatElfogadas'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <button v-on:click="save(0)" :disabled="mentes_folyamatban" type="button" class="button">Mentés</button>
              <button v-on:click="saveConfirm(1)" :disabled="mentes_folyamatban" type="button" class="button">Véglegesít</button>
            </div>
          </div>
        </div>
      </div>

      <div v-show="nezet.tipus == 'info'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Rendkívüli szociális ösztöndíj
            </div>
            <div class="article-text" v-html="nezet.tartalom"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';

export default {
  data: function() {
    return {
      form: {
        id: 0,
        values: {
          nev: '',
          neptunkod: '',
          szuletesiHely: '',
          szuletesiIdo: '',
          anyjaNeve: '',
          telefonszam: '',
          emailCim: '',
          kar: '',
          tagozat: '',
          kepzesNeve: '',
          kepzesSzintje: '',
          kepzesKodja: '',
          kepzesHelye: '',
          penzugyiStatusz: '',
          hallgatoiStatusz: '',
          osztondijindex: 0,
          rendkivuliSzocialisTamogatasTanevben: '0',
          rendkivuliSzocialisTamogatasTanevbenIgenylesDatum: '',
          tamogatasok: [],
          igazolasok: [],
          indoklas: '',
          igenyeltOsszeg: '',
          felevekSzama: 0,
          nyilatkozatElfogadas: 0,
          kivalasztottKepzesKodja: ''
        }
      },
      kepzesek: [],
      errors: [],
      fill_info: '',
      mentes_folyamatban: false,
      kategoriak: [],
      nezet: {
        tipus: 'info',
        tartalom: ''
      }
    }
  },

  computed: {
    igazolasokMaxFeltolthetoFajl() {
      return this.form.values.tamogatasok.length == 0 ? 1 : this.form.values.tamogatasok.length;
    }
  },

  mounted: function() {
    this.init();
  },

  methods: {
    init() {
      const _this = this;

      this.nezet.tipus = 'info';
      this.nezet.tartalom = 'Adatok betöltése folyamatban...';

      this.$root.ajax('form/rendkivuli_szocialis_osztondij/'+this.$route.query.id, {
        method: 'get',
        success: function(response) {
          _this.nezet.tipus = 'urlap';

          if (response.exception_error != false) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = response.exception_error;
            return;
          }

          _this.form.values.id = _this.$route.query.id;
          _this.kategoriak = response.kategoriak;

          if (response.kepzesek != undefined) {
            _this.kepzesek = response.kepzesek;
            _this.form.values.kivalasztottKepzesKodja = _this.kepzesek[0].value;
            _this.kepzesValt();
          }

          if (response.fill != false) {
            if (response.fill.status == 'Mentve') {
              _this.form.values = Object.assign({}, _this.form.values, response.fill.values);
              _this.form.values.kivalasztottKepzesKodja = response.fill.values.kepzesKodja;

            } else if (['Nyertes', 'Nem nyertes', 'Kizárva', 'Érvénytelen'].includes(response.fill.status)) {
              _this.nezet.tipus = 'info';
              _this.nezet.tartalom = '<div>Az Ön által beküldött pályázata az alábbi <a target="_blank" href="assets/urlap_kitoltesek/' + response.fill.pdf_filename + '">linkre</a> kattintva tekinthető meg.</div>';
              _this.nezet.tartalom += '<div>Az elbírált pályázat (' + response.fill.status + ') az alábbi <a target="_blank" href="assets/urlap_kitoltesek/' + response.fill.modify_pdf_filename + '">linkre</a> kattintva tekinthető meg.</div>';
            } else {
              _this.nezet.tipus = 'info';
              _this.nezet.tartalom = 'Az Ön által beküldött pályázata az alábbi <a target="_blank" href="assets/urlap_kitoltesek/' + response.fill.pdf_filename + '">linkre</a> kattintva tekinthető meg.';
            }
          }
        }
      });
    },

    saveConfirm: function(veglegesit) {
      const _this = this;

      swal({
        title: "Biztos véglegesíti a pályázatot?",
        text: "A pályázat véglegesítés után változtatni már nem lehetséges!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Mégsem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.save(veglegesit);
        }
      });
    },

    save: function(veglegesit) {
      var _this = this;

      this.errors = [];
      this.form.id = this.$route.query.id;
      _this.mentes_folyamatban = true;

      this.$root.ajax('form/rendkivuli_szocialis_osztondij_ment/', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          veglegesit: veglegesit
        },
        success: function(response) {
          _this.mentes_folyamatban = false;

          if (response.exception_error != false) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = response.exception_error;
            return;
          }

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            });

            return false;
          }

          _this.nezet.tipus = 'info';
          _this.nezet.tartalom = response.info;
        }
      });
    },

    kepzesValt() {
      const _this = this;

      this.kepzesek.map((kepzes) => {
        if (kepzes.kepzesKodja == _this.form.values.kivalasztottKepzesKodja) {
          _this.form.values.kar = kepzes.kar;
          _this.form.values.tagozat = kepzes.tagozat;
          _this.form.values.kepzesNeve = kepzes.kepzesNeve;
          _this.form.values.kepzesSzintje = kepzes.kepzesSzintje;
          _this.form.values.kepzesKodja = kepzes.kepzesKodja;
          _this.form.values.kepzesHelye = kepzes.kepzesHelye;
          _this.form.values.penzugyiStatusz = kepzes.penzugyiStatusz;
          _this.form.values.hallgatoiStatusz = kepzes.hallgatoiStatusz;
          _this.form.values.osztondijindex = kepzes.osztondijindex == null ? 0 : kepzes.osztondijindex;
          _this.form.values.nev = kepzes.nev;
          _this.form.values.neptunkod = kepzes.neptunkod;
          _this.form.values.szuletesiHely = kepzes.szuletesiHely;
          _this.form.values.szuletesiIdo = kepzes.szuletesiIdo;
          _this.form.values.anyjaNeve = kepzes.anyjaNeve;
          _this.form.values.telefonszam = kepzes.telefonszam == null ? '' : kepzes.telefonszam;
          _this.form.values.emailCim = kepzes.emailCim == null ? '' : kepzes.emailCim;
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// rendkivuli_szocialis_osztondij.vue?5d6be22d